import * as React from 'react';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { Error } from '../../components/Error';
import { SubcontractorManagementComponent } from '../../components/Nav/SubcontractorManagement';
import { Loading } from '../../components/Loading';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { ThunkDispatch } from 'redux-thunk';
import { IOrganization, OrganizationFeature } from '@pec/aion-ui-core/interfaces/organization';
import { DeepReadonly } from 'utility-types';
import { fetchIncomingSubcontractRequestsCount } from '@pec/aion-ui-core/actions/fetchSubcontractsRequestsCount';
import { fetchNotificationRecipientCount } from '@pec/aion-ui-core/actions/fetchNotificationRecipients';
import { hasPermission } from '@pec/aion-ui-core/actions/userInfo';
import { ActivityAction, ActivityResourceName } from '@pec/aion-ui-core/interfaces/activities';
import { UserInfoActivitiesType } from '@pec/aion-ui-core/interfaces/userInfo';

type OwnProps = {
  organization: DeepReadonly<IOrganization>;
};

const mapStateToProps = (state: CommonRootState) => ({
  ...state.organization,
  ...state.notifications,
  ...state.options,
  ...state.userInfo
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<CommonRootState, null, RootActions>,
  { organization }: OwnProps
) => ({
  fetchIncomingSubcontractRequestsCount: () => dispatch(fetchIncomingSubcontractRequestsCount(organization.id)),
  fetchNotificationRecipientCount: () => dispatch(fetchNotificationRecipientCount(organization.id))
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps;

class SubcontractorManagement extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    if (
      props.organization.features.includes(OrganizationFeature.Subcontractor) ||
      props.organization.features.includes(OrganizationFeature.PrimeContractor)
    ) {
      props.fetchIncomingSubcontractRequestsCount();
      props.fetchNotificationRecipientCount();
    }
  }

  hasGlobalPermission = (action: ActivityAction, resourceName: ActivityResourceName) =>
    hasPermission(this.props.userInfo, action, resourceName);

  hasOrganizationPermission = (action: ActivityAction, resourceName: ActivityResourceName) => {
    const {
      userInfo,
      organization: { id }
    } = this.props;

    return id
      ? hasPermission(userInfo, action, resourceName, [
          {
            type: UserInfoActivitiesType.Organization,
            id
          }
        ])
      : false;
  };

  render() {
    const {
      organization,
      isFetching,
      fetchError,
      navExpanded,
      incomingSubcontractRequests,
      notificationRecipients
    } = this.props;
    const isClient = organization.features.includes(OrganizationFeature.Client);

    const notificationCount = isClient
      ? Number(notificationRecipients)
      : Number(incomingSubcontractRequests) + Number(notificationRecipients);

    return !isFetching && !fetchError ? (
      <SubcontractorManagementComponent
        navExpanded={navExpanded}
        notificationCount={notificationCount}
        organization={organization}
      />
    ) : fetchError ? (
      <Error />
    ) : (
      <Loading />
    );
  }
}

export const SubcontractorManagementContainer = connect(mapStateToProps, mapDispatchToProps)(SubcontractorManagement);
